export const ShieldIcon = () => {
  return (
    <i className='material-symbols-shield-outline-rounded align-middle text-xl m-[2px] bg-[var(--mui-palette-primary-main)]' />
  );
};
